

























import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    relatorio: {},
    periodo: {
      type: String,
    },
  },
})

export default class ComponentRelatorioRecebimentoPaciente extends Vue {
  data() {
    return {
      status: null,
    }
  }

  back() {
    this.$router.go(-1)
  }

  mounted() {
    // @ts-ignore
    this.status = this.$route.params.status
  }
}
